import createApolloClient from "@trustime/common/apollo-client";
import { getUser } from "@trustime/common/user-service";

const client = createApolloClient(getUser);

export default client;
